import { z } from 'zod';

import { EntityIDdigitsRegex, EntityNameRegex } from '~/constants/forms';

export const idnSchema = z.object({
  name: z
    .string()
    .min(1, 'Required')
    .regex(EntityNameRegex, "Can't contain symbols")
    .max(40, 'IDN Name is too long'),
  id: z
    .string()
    .min(1, 'Required')
    .regex(EntityIDdigitsRegex, 'Should be valid')
    .max(6, 'IDN ID is too long'),
  address: z.string().min(1, 'Required').max(100, 'Address is too long'),
  addressLine2: z.string().max(100, 'Address Line 2 is too long').optional(),
  city: z.string().min(1, 'Required').max(50, 'City is too long'),
  state: z.string().min(1, 'Required').max(50, 'State is too long'),
  zipCode: z.string().min(1, 'Required').max(20, 'Zip Code is too long'),
  country: z.string().min(1, 'Required').max(6, 'Country is too long'),
  phone: z.e164('Enter a valid mobile number').or(z.literal('')).optional(),
});
